<div class="customize-page-popup" style="display: none;">
    <div class="customize-page-popup-inner">
        <div class="block">
            <div role="tabpanel" class="custom-tabpanel">
                <ul role="tablist" class="nav nav-tabs nav-justified">
                    <li role="presentation" class="active">
                        <a href="#SideWidgets" (click)="openSideWidget()" aria-controls="SideWidgets" role="tab" data-toggle="tab">
                            Side Widgets
                         </a>
                    </li>
                    <li role="presentation">
                        <a href="#CenterWidgets" (click)="openCenterWidget()" aria-controls="CenterWidgets" role="tab" data-toggle="tab">
                            CENTRE Widgets
                         </a>
                    </li>
                </ul>
                <!-- Tab panes-->
                <div class="tab-content">
                    <div id="SideWidgets" role="tabpanel" class="tab-pane fade show active">
                        <ul class="inner-circle-list">
                            <li>
                                <a draggable="true" href="javascript:void(0);" id="UpcomingtrainingsComponent" (dragstart)="onDragStart($event,'sw')" class="suggested-drop-link">
                                    <img src="assets/img/suggested.jpg" alt="Image">
                                </a><span>SUGGESTED</span>
                            </li>
                            <li>
                                <a draggable="true" href="javascript:void(0);" id="UpcomingeventComponent" (dragstart)="onDragStart($event,'sw')" class="event-drop-link">
                                    <img src="assets/img/upcoming.jpg" alt="Image">
                                </a><span>UPCOMING</span>
                            </li>
                            <!-- <li><a draggable="true" href="javascript:void(0);" id="my-activity" (dragstart)="onDragStart($event)" class="my-activity-drop-link"><img src="assets/img/my-activity.jpg" alt="Image"></a><span>MY ACTIVITY</span></li> -->
                            <li>
                                <a draggable="true" href="javascript:void(0);" id="MytasksComponent" (dragstart)="onDragStart($event,'sw')" class="calendar-drop-link">
                                    <img src="assets/img/tasks.jpg" alt="Image">
                                </a><span>TASKS</span>
                            </li>
                            <!-- <li><a draggable="true" href="javascript:void(0);" id="leaderboard" (dragstart)="onDragStart($event)" class="leaderboard-drop-link"><img src="assets/img/leaderboard.jpg" alt="Image"></a><span>LEADERBOARD</span></li> -->
                        </ul>
                    </div>
                    <div id="CenterWidgets" role="tabpanel" class="tab-pane fade">
                        <ul class="inner-circle-list width-4">
                            <!-- <li>
                                <a draggable="true" href="javascript:void(0);" id="MyLearnings" (dragstart)="onDragStart($event, 'cw')">
                                    <img src="assets/img/my-learnings.jpg" alt="Image">
                                </a><span>My Learning</span>
                            </li>-->
                            <li>
                                <a draggable="true" href="javascript:void(0);" id="TimelineComponent" (dragstart)="onDragStart($event, 'mw')">
                                    <img src="assets/img/buzzline.jpg" alt="Image">
                                </a><span>Collaborate</span>
                            </li>
                            <li>
                                <a draggable="true" href="javascript:void(0);" id="LearningCalendar" (dragstart)="onDragStart($event, 'mw')">
                                    <img src="assets/img/learning-calendar.jpg" alt="Image">
                                </a><span>Learning Calendar</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>